export const PAYMENT_REQUEST_AMOUNT_STATUS = {
  DISBURSED_AMOUNT_TODAY: 'DISBURSED_AMOUNT_TODAY',
  PENDING_AMOUNT: 'PENDING_AMOUNT',
  PENDING_AMOUNT_AUTOMATED: 'PENDING_AMOUNT_AUTOMATED',
};

export const PAYMENT_REQUEST_STATUSES = {
  REVIEW_NOW: 'REVIEW_NOW',
  APPROVED: 'APPROVED',
  ON_HOLD: 'ON_HOLD',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  PROCESSING: 'PROCESSING',
  DISBURSED: 'DISBURSED',
  DISBURSEMENT_FAILED: 'DISBURSEMENT_FAILED',
};

export const PAYMENT_REQUEST_NEED_REVIEW_STATUS = [
  PAYMENT_REQUEST_STATUSES.REVIEW_NOW,
  PAYMENT_REQUEST_STATUSES.REJECTED,
];

export const PAYMENT_REQUEST_CAN_REVIEW_STATUS = [
  ...PAYMENT_REQUEST_NEED_REVIEW_STATUS,
  PAYMENT_REQUEST_STATUSES.ON_HOLD,
  PAYMENT_REQUEST_STATUSES.APPROVED,
  PAYMENT_REQUEST_STATUSES.DISBURSEMENT_FAILED,
  PAYMENT_REQUEST_STATUSES.REJECTED,
];

export const PAYMENT_REQUEST_STATUS_COLORS = {
  [PAYMENT_REQUEST_STATUSES.APPROVED]: 'primary',
  [PAYMENT_REQUEST_STATUSES.CANCELLED]: 'danger',
  [PAYMENT_REQUEST_STATUSES.DISBURSED]: 'success',
  [PAYMENT_REQUEST_STATUSES.DISBURSEMENT_FAILED]: 'danger',
  [PAYMENT_REQUEST_STATUSES.ON_HOLD]: 'orangeyYellow',
  [PAYMENT_REQUEST_STATUSES.PROCESSING]: 'secondary',
  [PAYMENT_REQUEST_STATUSES.REJECTED]: 'danger',
  [PAYMENT_REQUEST_STATUSES.REVIEW_NOW]: 'orangeyYellow',
};

export const PAYMENT_REQUEST_DISBURSABLE_STATUS = [
  PAYMENT_REQUEST_STATUSES.APPROVED,
  PAYMENT_REQUEST_STATUSES.DISBURSEMENT_FAILED,
];

export const SHIPPER_PAYMENT_REQUEST_REJECTION_TYPE = {
  DELIVERY_ORDER_PROBLEM: 'DELIVERY_ORDER_PROBLEM',
  REQUEST_FROM_AR: 'REQUEST_FROM_AR',
  OTHER: 'OTHER',
};

export const PAYMENT_REQUEST_REJECTION_TYPE = {
  INVOICE_PROBLEM: 'INVOICE_PROBLEM',
  DELIVERY_ORDER_PROBLEM: 'DELIVERY_ORDER_PROBLEM',
  REQUEST_FROM_AP: 'REQUEST_FROM_AP',
};

export const PAYMENT_REQUEST_BUSINESS_CONTEXT = {
  TRANSPORTER_DEDICATED: 'TRANSPORTER_DEDICATED',
  TRANSPORTER_ONCALL: 'TRANSPORTER_ONCALL',
  SHIPPER: 'SHIPPER',
};

export const PAYMENT_REQUEST_FORM_TYPE = {
  PREVIEW: 'PREVIEW',
  REVIEW: 'REVIEW',
  DETAILS: 'DETAILS',
};

export const DISBURSEMENT_TARGET = {
  SHIPPER: 'SHIPPER',
  TRANSPORTER: 'TRANSPORTER',
};

export const PAYABLE_ADJUSTMENT_FEE_TYPE = {
  DOWNTIME: 'DOWNTIME',
  UNFULFILLED: 'UNFULFILLED',
  FINAL_AMOUNT: 'FINAL_AMOUNT',
  PENALTY: 'PENALTY',
  CLAIMS: 'CLAIMS',
  INSURANCE: 'INSURANCE',
  PRICE: 'PRICE',
  OTHER: 'OTHER',
  CONTRACT_TERMINATION: 'CONTRACT_TERMINATION',
};

export const CONTRACT_SUPPLY_TYPE = {
  ALL_IN: 'ALL_IN',
  DRIVER_ONLY_RENTAL: 'DRIVER_ONLY_RENTAL',
  FLEET_ONLY_RENTAL: 'FLEET_ONLY_RENTAL',
  FLEET_AND_DRIVER_RENTAL: 'FLEET_AND_DRIVER_RENTAL',
};

export const TRANSPORTER_DEDICATED_FEE_TYPE = {
  RENT_FEE: 'RENT_FEE',
  COD_FEE: 'COD_FEE',
  CONTRACT_TERMINATION: 'CONTRACT_TERMINATION',
  TIP_FEE: 'TIP_FEE',
};

export const TRANSPORTER_ONCALL_FEE_TYPE = {
  SHIPMENT_FEE: 'SHIPMENT_FEE',
};

export const ALL_TRANSPORTER_FEE_TYPE = {
  ...PAYABLE_ADJUSTMENT_FEE_TYPE,
  ...TRANSPORTER_DEDICATED_FEE_TYPE,
  ...TRANSPORTER_ONCALL_FEE_TYPE,
};

export const TRANSPORTER_DEDICATED_FEE_TYPES = Object.keys(TRANSPORTER_DEDICATED_FEE_TYPE);
export const TRANSPORTER_ONCALL_FEE_TYPES = Object.keys(TRANSPORTER_ONCALL_FEE_TYPE);
export const TAXED_FEE_TYPES = [
  ALL_TRANSPORTER_FEE_TYPE.SHIPMENT_FEE,
  ALL_TRANSPORTER_FEE_TYPE.RENT_FEE,
  ALL_TRANSPORTER_FEE_TYPE.COD_FEE,
  ALL_TRANSPORTER_FEE_TYPE.PRICE,
  ALL_TRANSPORTER_FEE_TYPE.TIP_FEE,
  ALL_TRANSPORTER_FEE_TYPE.CONTRACT_TERMINATION,
];

export const PAYABLE_PAYMENT_SCHEME = {
  PAYMENT_SCHEME_100: 'PAYMENT_SCHEME_100',
  PAYMENT_SCHEME_25_25_25_25: 'PAYMENT_SCHEME_25_25_25_25',
  PAYMENT_SCHEME_50_50: 'PAYMENT_SCHEME_50_50',
  PAYMENT_SCHEME_50_50_TIP: 'PAYMENT_SCHEME_50_50_TIP',
};

export const PAYABLE_ITEM_STATUS = {
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  NOT_DUE: 'NOT_DUE',
  HOLD: 'HOLD',
  APPROVE: 'APPROVE',
  CANCELLED: 'CANCELLED',
};

export const PAYABLE_ITEM_STATUS_COLOR = {
  [PAYABLE_ITEM_STATUS.HOLD]: 'warning',
  [PAYABLE_ITEM_STATUS.APPROVE]: 'primary',
};

export const FEE_REQUEST_STATUS = {
  ...PAYABLE_ITEM_STATUS,
  REVIEWED: 'REVIEWED',
  REQUESTED: 'REQUESTED',
  FINANCE_APPROVED: 'FINANCE_APPROVED',
  FINANCE_ON_HOLD: 'FINANCE_ON_HOLD',
  FINANCE_CANCELLED: 'FINANCE_CANCELLED',
  FINANCE_REJECTED: 'FINANCE_REJECTED',
  REQUEST_SENT: 'REQUEST_SENT',
  REQUEST_APPROVED: 'REQUEST_APPROVED',
  REQUEST_REJECTED: 'REQUEST_REJECTED',
  DISBURSED: 'DISBURSED',
  PROCESSING: 'PROCESSING',
  DISBURSEMENT_FAILED: 'DISBURSEMENT_FAILED',
};

export const FEE_REQUEST_STATUS_COLOR = {
  [FEE_REQUEST_STATUS.NEEDS_REVIEW]: 'danger',
  [FEE_REQUEST_STATUS.NOT_DUE]: 'primary',
  [FEE_REQUEST_STATUS.HOLD]: 'warning',
  [FEE_REQUEST_STATUS.APPROVE]: 'primary',
  [FEE_REQUEST_STATUS.CANCELLED]: 'danger',
  [FEE_REQUEST_STATUS.REVIEWED]: 'primary',
  [FEE_REQUEST_STATUS.REQUEST_SENT]: 'primary',
  [FEE_REQUEST_STATUS.REQUEST_APPROVED]: 'primary',
  [FEE_REQUEST_STATUS.REQUEST_REJECTED]: 'danger',
  [FEE_REQUEST_STATUS.DISBURSED]: 'success',
  [FEE_REQUEST_STATUS.DISBURSEMENT_FAILED]: 'primary',
  [FEE_REQUEST_STATUS.PROCESSING]: 'secondary',
  [FEE_REQUEST_STATUS.REQUESTED]: 'primary',
  [FEE_REQUEST_STATUS.FINANCE_ON_HOLD]: 'primary',
  [FEE_REQUEST_STATUS.FINANCE_APPROVED]: 'primary',
  [FEE_REQUEST_STATUS.FINANCE_REJECTED]: 'danger',
  [FEE_REQUEST_STATUS.FINANCE_CANCELLED]: 'danger',
};

export const LICENSE_PLATE_TYPE = {
  YELLOW_PLATE: 'YELLOW_PLATE',
  BLACK_PLATE: 'BLACK_PLATE',
};

export default {};
